<template>
  <div class="progress-box">
    <div class="progress progress-primary">
      <el-progress :percentage="formatRatio(fileInfo.rate)" :format="() => ''">
      </el-progress>
    </div>
    <span class="text" v-if="fileInfo.status === 1">{{
      formatText(fileInfo.rate)
    }}</span>
    <el-tooltip
      :content="getToolTipContent(fileInfo)"
      :effect="$theme.tooltipKey()"
      placement="top"
    >
      <i
        ref="iconRef"
        :class="`origin-icon ${getIcon(fileInfo.status)}`"
        :style="`color:${getIconColor(fileInfo.status)}`"
        :id="`${
          fileInfo.status === 2
            ? `${mark ? `${mark}` : ''}continue-${fileInfo.id}`
            : ''
        }`"
        @click="uploadControl(fileInfo)"
      ></i>
    </el-tooltip>
  </div>
</template>

<script>
import { formatRatio, formatText } from "@/utils/generalMethods";

export default {
  data() {
    return {};
  },
  props: {
    mark: String,
    fileInfo: Object,
    uploadControl: Function,
  },
  created() {},
  mounted() {},
  methods: {
    getIcon(status) {
      this.removeUploadBtn();
      let icon = "";
      switch (status) {
        case 0:
          icon = "el-icon-time";
          break;
        case 1:
          icon = "el-icon-video-pause icon";
          break;
        case 2:
          icon = "el-icon-video-play upload-icon-btn";
          break;
        // case 3:
        //   icon = "el-icon-video-pause";
        //   break;
        case 4:
          icon = "el-icon-circle-check";
          break;
        case 5:
          icon = "el-icon-warning";
          break;
        case 6:
          icon = "el-icon-loading";
          break;
        case 8:
          icon = "el-icon-loading";
          break;
      }

      return icon;
    },
    getProgressColor(status) {
      let color = "";
      switch (status) {
        case 0:
          color = "#ebeef5";
          break;
        case 1:
          color = "#0bdddb";
          break;
        case 2:
          color = "#ee910b";
          break;
        // case 3:
        //   color = "#ee910b";
        //   break;
        case 4:
          color = "#01ff31";
          break;
        case 5:
          color = "#01ff31";
          break;
        case 6:
          color = "#01ff31 ";
          break;
        case 8:
          color = "#01ff31 ";
          break;
      }
      return color;
    },
    getIconColor(status) {
      let color = "";
      switch (status) {
        case 0:
          color = "#696969";
          break;
        case 1:
          color = "#0bdddb";
          break;
        case 2:
          color = "#73FAFD";
          break;
        // case 3:
        //   color = "#ee910b";
        //   break;
        case 4:
          color = "#01ff31";
          break;
        case 5:
          color = "#f56c6c";
          break;
        case 6:
          color = "#5cb6ff ";
          break;
        case 8:
          color = "#5cb6ff ";
          break;
      }
      return color;
    },
    getToolTipContent(fileInfo) {
      let content = "";
      let status = fileInfo.status;
      switch (status) {
        case 1:
          content = "暂停上传";
          break;
        case 2:
          content = "继续上传";
          break;
        case 6:
          content = "上传成功-解析中";
          break;
        default:
          content = fileInfo.status.displayName;
          break;
      }
      return content;
    },
    removeUploadBtn() {
      this.$nextTick(() => {
        if (!this.$refs.iconRef.id) {
          let childNodes = this.$refs.iconRef.childNodes;
          for (let i = 0; i < childNodes.length; i++) {
            childNodes[i].remove();
          }
        }
      });
    },

    formatRatio,
    formatText,
  },
};
</script>

<style lang="less">
@import "@/assets/css/publishSearch.less";
.progress-box {
  display: flex;
  text-align: center;

  .progress {
    width: 80%;

    .el-progress {
      line-height: 32px;
    }

    .el-progress-bar {
      border: 1px solid #73fbfd;
      padding: 2px;
      border-radius: 10px;
      margin-left: -60px;

      .el-progress-bar__outer {
        background-color: transparent !important;

        .el-progress-bar__inner {
          line-height: 12px;
          background: var(--process-bar-bg);
        }
      }
    }
  }

  .origin-icon {
    display: block;
    width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 16px;
    z-index: 999;
    cursor: pointer;
  }

  .icon {
    display: none;
  }

  .text {
    display: inline;
    flex-shrink: 0;
    line-height: 32px;
    color: #0bdddb;
  }

  &:hover {
    .text {
      display: none;
    }

    .icon {
      display: inline;
      cursor: pointer;
    }
  }
}
</style>